import React from 'react';
import { Grid } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons';
import { track } from 'shared';
import { useLocation } from 'react-router-dom';
import { useUserContext } from 'UserContext';
import { trackReferralEngagement } from 'api/UserApi';

export default function WebShareLink({
    message,
    link,
    backgroundColor,
    referralContext,
}: {
    message: string;
    link: string;
    backgroundColor?: string;
    referralContext?: string;
}) {
    const { user } = useUserContext();
    const location = useLocation();

    return (
        <Grid
            style={{
                borderRadius: 50,
                backgroundColor: backgroundColor ?? '#fff',
                padding: 10,
                textAlign: 'center',
                margin: 'auto',
                width: 48,
            }}
            onClick={() => {
                track('Referral Shared Via Web Share');
                if (referralContext && user) {
                    trackReferralEngagement(user.id, location.pathname, `${referralContext}: Web Share Link`).then(
                        (response) => {
                            navigator.share({
                                text: message,
                                url: `${link}&reid=${response.id}`,
                            });
                        },
                    );
                } else {
                    navigator.share({
                        text: message,
                        url: link,
                    });
                }
            }}
        >
            <FontAwesomeIcon size="lg" icon={faArrowUpFromBracket} />
        </Grid>
    );
}
